import { createClient } from '.';

// This has no stayAuthorized reaction. Use it in order to throw 401/403
// instead of sending the user to a login page somewhere.
export default createClient();
